import { render } from "./FileLocalMultiUploadRedesigned.vue?vue&type=template&id=9331230c&scoped=true&ts=true"
import script from "./FileLocalMultiUploadRedesigned.vue?vue&type=script&lang=ts"
export * from "./FileLocalMultiUploadRedesigned.vue?vue&type=script&lang=ts"

import "./FileLocalMultiUploadRedesigned.vue?vue&type=style&index=0&id=9331230c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9331230c"]])

export default __exports__